import { PageMetadata } from '@hooks/usePageMetadata'
import { TargetContentType } from '@widgets/Teaser/types'

export enum Vtype {
  SHORTFORM = 'shortform',
  LONGFORM = 'longform',
  LIVESTREAM = 'livestream',
  DEFAULT = '',
}

export type Sound = 'on' | 'off'

export type Sherlock = string[]

interface ServerSideVastUrl {
  queryString: { [key: string]: any }
  url: string
}

export interface PlainAdEvents {
  adReady?: (data: { width: number; height: number }) => void
  adLoaded?: (data: { width: number; height: number }) => void
  adEmpty?: (data: { message: string }) => void
  adError?: (data: { message: string }) => void
  adStatus?: (data: {
    status: 'adReady' | 'adLoaded' | 'adEmpty' | 'adError'
    detail: Record<string, unknown>
  }) => void
}

export interface VideoAdEvents {
  adReady?: (data: {
    vmapUrl?: string
    serverSideVastUrl?: ServerSideVastUrl
    message?: any
  }) => void
  adLoaded?: (data: {
    vmapUrl?: string
    serverSideVastUrl?: ServerSideVastUrl
    message?: any
  }) => void
  adEmpty?: (data: { message: string }) => void
  adError?: (data: { message: string }) => void
  adStatus?: (data: {
    status: 'adReady' | 'adLoaded' | 'adEmpty' | 'adError'
    detail: Record<string, unknown>
  }) => void
}

interface CommonAdOptions {
  slot: string
  container: string
}

export interface PlainAdOptions extends CommonAdOptions {
  events?: PlainAdEvents
  targeting: {
    placement: string
    syndication?: string
    contenttype?: TargetContentType
    articleid?: string
    articleid_fr?: string
    subsectionid: PageMetadata['sectionIds']
    sherlock?: Sherlock
    pagetype: 'article' | 'overview'
  }
}

interface VideoAdOptions extends CommonAdOptions {
  source: string
  channel?: string
  events?: VideoAdEvents
  targeting: {
    vtype: Vtype
    syndication?: string
    sherlock?: Sherlock
    sound: Sound
  }
}

type AdOptions = PlainAdOptions | VideoAdOptions

export type RegisterSlotType = (options: AdOptions) => void

export interface AdmTagMan {
  q: unknown[]
  registerSlot: RegisterSlotType
  init: (data: Record<string, unknown>) => void
  loadSlots: () => void
}
